import dayjs from "@/lib/dayjs";

import { getTodaysDate } from "../get-todays-date";

/**
 * 操作日の月の最初の日と最後の日を取得する
 */
export function getMonthRange() {
	const today = getTodaysDate();

	const firstDay = dayjs(today).startOf("month").format("YYYY-MM-DD");
	const lastDay = dayjs(today).endOf("month").format("YYYY-MM-DD");

	return { firstDay, lastDay };
}
